module.exports = __webpack_public_path__ + "img/features03-03.66bca7e.png";